import React, { useEffect, useState } from "react";
import { Box, Typography, Container, CircularProgress } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { ref, get } from "firebase/database";

import { rtdb } from "../services/firebase";
import ProductCard from "./ProductCard";

const TopSellersCarousel = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        carregarTopSales();
    }, []);

    async function carregarTopSales() {
        try {

            const appSnap = await get(ref(rtdb, "app/topSales"));
            if (!appSnap.exists()) {
                setProducts([]);
                return;
            }

            const ids = appSnap.val();
            if (!Array.isArray(ids) || ids.length === 0) {
                setProducts([]);
                return;
            }

            const requests = ids.map((id) =>
                get(ref(rtdb, `products/${id}`))
            );

            const results = await Promise.all(requests);

            const loadedProducts = results
                .map((snap, index) => {
                    if (!snap.exists()) return null;

                    const data = snap.val();

                    return {
                        id: ids[index],
                        ...data,
                        image: data.imagens?.[0] || null,
                    };
                })
                .filter(Boolean);

            setProducts(loadedProducts);
        } catch (err) {
            console.error("Erro ao carregar topSales:", err);
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (products.length === 0) return null;

    return (
        <Container
            maxWidth="xl"
            disableGutters
            sx={{ mt: 10, px: 0, pb: 10 }}
        >
            <Typography
                sx={{
                    fontWeight: 700,
                    fontSize: 28,
                    mb: 4,
                    color: "var(--branco)",
                    p: 1.5,
                    borderRadius: "20px",
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: "var(--azul)",
                    mx: 1,
                }}
            >
                Mais Vendidos
            </Typography>

            <Swiper
                modules={[Navigation]}
                navigation
                slidesPerView="auto"
                spaceBetween={20}
                style={{
                    width: "100%",
                    paddingTop: "10px",
                    paddingBottom: "40px",
                }}
            >
                {products.map((product) => (
                    <SwiperSlide
                        key={product.id}
                        style={{
                            width: "330px",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <ProductCard product={product} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </Container>
    );
};

export default TopSellersCarousel;
